import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'antd';
import { Modal } from 'ui';

export type AttemptLinkingChoiceMode = 'mixed_statuses' | 'all_completed';

export interface AttemptLinkingChoiceModalProps {
    open: boolean;
    mode: AttemptLinkingChoiceMode;
    totalSelected: number;
    completedCount: number;
    onCancel: () => void;
    onCreateNewAttempt: () => void;
    onUseExistingAttempt: () => void;
}

const AttemptLinkingChoiceModal: React.FC<AttemptLinkingChoiceModalProps> = ({
    open,
    mode,
    totalSelected,
    completedCount,
    onCancel,
    onCreateNewAttempt,
    onUseExistingAttempt,
}) => {
    const intl = useIntl();

    const title = intl.formatMessage({ id: 'lectures.session_planning.attempt_choice.title' });

    const content =
        mode === 'mixed_statuses'
            ? intl.formatMessage(
                  { id: 'lectures.session_planning.attempt_choice.mixed_statuses' },
                  { completedCount, totalSelected }
              )
            : intl.formatMessage(
                  { id: 'lectures.session_planning.attempt_choice.all_completed' },
                  { completedCount }
              );

    const footer =
        mode === 'mixed_statuses' ? (
            <Button onClick={onCancel}>{intl.formatMessage({ id: 'general.cancel' })}</Button>
        ) : (
            <>
                <Button onClick={onCancel}>{intl.formatMessage({ id: 'general.cancel' })}</Button>
                <Button onClick={onUseExistingAttempt}>
                    {intl.formatMessage({ id: 'lectures.session_planning.attempt_choice.use_existing' })}
                </Button>
                <Button type="primary" onClick={onCreateNewAttempt}>
                    {intl.formatMessage({ id: 'lectures.session_planning.attempt_choice.create_new' })}
                </Button>
            </>
        );

    return (
        <Modal open={open} title={title} onCancel={onCancel} footer={footer}>
            {content}
        </Modal>
    );
};

export default AttemptLinkingChoiceModal;

